var map = {
	"./mailing_a": "pVin",
	"./mailing_a/": "pVin",
	"./mailing_a/index": "pVin",
	"./mailing_a/index.js": "pVin",
	"./mailing_a/mailing-a.module.scss": "lNX/",
	"./testimonials": "jSER",
	"./testimonials/": "jSER",
	"./testimonials/index": "jSER",
	"./testimonials/index.js": "jSER",
	"./testimonials/testimonials-popup.module.scss": "56s6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FMA7";